import { IconButton, TooltipHost } from '@fluentui/react';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from '../../redux/message/actions';

type Props = {
  text: string;
  message?: string;
  disabled?: boolean;
  tooltip?: string;
};

export default function CopyButton({ text, message, disabled, tooltip }: Props) {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    if (window.navigator && window.navigator.clipboard) {
      window.navigator.clipboard.writeText(text).then(() => {
        dispatch(toast({ type: 'info', title: message || 'Copied to clipboard' }));
      });
    }
  }, [dispatch, text, message]);

  if (tooltip) {
    return (
      <TooltipHost content={tooltip}>
        <IconButton disabled={disabled} iconProps={{ iconName: 'Copy' }} onClick={onClick} />
      </TooltipHost>
    );
  }

  return <IconButton disabled={disabled} iconProps={{ iconName: 'Copy' }} onClick={onClick} />;
}
